// Copyright (C) 2017-2023 Smart code 203358507

const Popup = require('./Popup');

module.exports = Popup;
